/*
 *  -----------------------------------------------------------------------
 *    <copyright file="summary-info.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import React from 'react';

import { useTranslation } from 'hooks';
import { StudyFields } from 'queries/generated/fragments.generated';
import ItemWrapper from 'views/components/core/item-wrapper';

const SummaryInfo = ({ study, studySummary }: { study: StudyFields; studySummary: any }) => {
    const { t } = useTranslation();

    return (
        <ItemWrapper title={t('cm:studySummary')} hideItemNumber>
            <div className="study-summary-wrapper">
                <p className="text-wrap">
                    <p className="title">{t('cm:study_num')}:</p> {study?.studyNumber}
                </p>
                {study?.sponsor ? (
                    <p className="text-wrap">
                        <p className="title">{t('admin:sponsor')}:</p> {study.sponsor}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numScreened ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:screenedSubjects')}:</p>
                        {studySummary.screenedSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numScreenFailed ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:screenedFailedSubjects')}:</p>
                        {studySummary.screenedFailedSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numEnrolled ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:enrolledSubjects')}:</p>
                        {studySummary.enrolledSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numRandomised ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:#randomised')}:</p>
                        {studySummary.randomisedSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numTreatmentDiscontinued ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:treatmentDiscontinuedSubjects')}:</p>{' '}
                        {studySummary.treatmentDiscontinuedSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numStudyDiscontinued ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:discontinuedSubjects')}:</p>
                        {studySummary.discontinuedSubjects}
                    </p>
                ) : null}
                {study?.studySummaryConfiguration.numCompleted ? (
                    <p className="text-wrap">
                        <p className="title">{t('cm:numCompleted')}:</p>
                        {studySummary.numCompleted}
                    </p>
                ) : null}
            </div>
        </ItemWrapper>
    );
};

export default SummaryInfo;
